module.exports = __webpack_public_path__ + "static/img/zanwuhsj.1ca8463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zanwuhsj.png
// module id = q1tv
// module chunks = 3